import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { CustomAlarmDefinition } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';

type TFunction = (key: string) => string;

const mapNotificationType = (item: CustomAlarmDefinition, t: TFunction): string => {
    const types: string[] = [];

    if (item.grayNotification.enabled) {
        types.push(t('settings.devices.custom-alarms.list.notification-type.info'));
    }
    if (item.yellowNotification.enabled) {
        types.push(t('settings.devices.custom-alarms.list.notification-type.warning'));
    }
    if (item.redNotification.enabled) {
        types.push(t('settings.devices.custom-alarms.list.notification-type.alarm'));
    }

    return types.join(', ');
};

const mapOptionalSettings = (item: CustomAlarmDefinition, t: TFunction): string => {
    if (item.isResettable && item.requiresCommentOnReset) {
        return t('settings.devices.custom-alarms.list.optional-settings.reset-with-comment');
    }

    if (item.isResettable) {
        return t('settings.devices.custom-alarms.list.optional-settings.reset');
    }

    return '-';
};

export const mapCustomAlarmDefinitionToListItem = (item: CustomAlarmDefinition, t: TFunction): CustomAlarmListItem => ({
    id: item.id,
    notificationName: item.name,
    trackedEvents: item.eventsToTrack.map((event) => event.displayName),
    trackingPeriodDays: item.trackingTypeConfiguration.windowDays,
    notificationType: mapNotificationType(item, t),
    optionalSettings: mapOptionalSettings(item, t),
    active: item.active,
});
